import Modal from './Modal';
import useUser from '../hooks/useUser';
import { useModal } from "../contexts";
import { useTranslation } from 'react-i18next';

interface Props {
  oauthUrl: string;
  onClose?: () => void;
}

function OAuthModalCopper(props: Props) {
  const { closeModal } = useModal();
  const { refreshUser } = useUser();
  const { t } = useTranslation();

  function handleInstallIntegration() {
    window.open(props.oauthUrl, "_blank");
    window.addEventListener("focus", getCurrentUserOnFocus);
  }

  async function getCurrentUserOnFocus() {
    window.removeEventListener("focus", getCurrentUserOnFocus);

    refreshUser();
    closeModal(props.onClose);
  }

  return (
    <Modal
      title={t("Connect Copper to Portant")}
      subtitle={t("Portant requires access to opportunities within your Copper account.")}
      size='sm'
      primaryButtonProps={{
        text: t("Connect Copper to Portant"),
        onClick: handleInstallIntegration
      }}
    >
    </Modal>
  );
}

export default OAuthModalCopper;
